import React, { Component } from "react";
import ReactTable from "react-table";
import { Configurations } from "../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import './Cile-Spdl-Orders.scss';
import axios from "axios";
import moment from 'moment';


class CileSpdlOrders extends Component {
    constructor(props) {
        super(props);

        this.toggleModalExcluirPedido = this.toggleModalExcluirPedido.bind(this);
        this.excluirPedido = this.excluirPedido.bind(this);
        this.statusSPDLOrder = this.statusSPDLOrder.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.atualizarQtdMelhorEnvio = this.atualizarQtdMelhorEnvio.bind(this);
        this.toggleEditar = this.toggleEditar.bind(this);
        this.editarQtdMelhorEnvio = this.editarQtdMelhorEnvio.bind(this);
        this.carregarDetalhesRemessa = this.carregarDetalhesRemessa.bind(this);
        this.handleError = this.handleError.bind(this);
        this.enviarRemessa = this.enviarRemessa.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            spdlPedidos: [],
            isLoadingExcluirPedido: false,
            isLoadingAtualizar: false,
            isLoadingEditar: false,
            isLoadingCarregarDetalhesRemessa: true,
            flagAtualizar: true,
            idRemessa: this.props.idRemessaDetalhes
        }

        this.columns = [
            {
                Header: "",
                width: 30,
                className: "text-center pointer",
                Cell: row => {
                    return (
                        <span>{row.index + 1}</span>
                    )
                }
            },
            {
                Header: "Pedido",
                accessor: "idPedido",
                width: 60,
                className: "text-center pointer"
            },
            {
                Header: "Solicitante",
                accessor: "solicitante",
                width: 300,
                className: "text-center pointer"
            },
            {
                Header: "Transp.",
                accessor: "transportadora",
                width: 80,
                className: "text-center pointer"
            },
            {
                Header: "Produto(s)",
                accessor: "nomeProdutos",
                width: 400,
                className: "text-center pointer produtos",
                Cell: row => (
                    row.value.map((item, index) => {
                        return <p key={index} className="m-0">{item}</p>
                    })
                )
            },
            {
                Header: "",
                accessor: "idPedido",
                className: "text-center pointer",
                Cell: row => {
                    const enviada = this.state.detalhesRemessa.idStatusRemessa === 2;
                    return (
                        !enviada && (
                            <i onClick={() => this.toggleModalExcluirPedido(row.value)} className={`far fa-trash-alt text-danger ml-2 cursor-pointer`}></i>
                        )
                    )

                }
            }
        ]
    }

    componentWillMount() {
        this.carregarDetalhesRemessa();
    }

    carregarDetalhesRemessa() {
        this.setState({ isLoadingCarregarDetalhesRemessa: true })

        axios.get(this.Configurations.apiBasePath + `/logistica-cile/remessas/detalhes/${this.props.idRemessaDetalhes}`).then(response => {
            this.setState({
                detalhesRemessa: response.data.dados,
                inputQtdMelhorEnvio: response.data.dados.qtdMelhorEnvio
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingCarregarDetalhesRemessa: false }))
    }

    excluirPedido(id) {
        this.setState({ isLoadingExcluirPedido: true })
        axios.delete(this.Configurations.apiBasePath + `/logistica-cile/remessas/excluir/${this.props.idRemessaDetalhes}/${this.state.idPedidoExcluido}`).then(response => {
            this.setState({
                idPedidoExcluido: Number(id),
            })
            this.carregarDetalhesRemessa();
            // this.props.carregarListaRemessas({});
            this.toggleModalExcluirPedido();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingExcluirPedido: false }))
    }

    toggleModalExcluirPedido(id) {
        this.setState({
            idPedidoExcluido: id,
            isOpenModalExcluirPedido: !this.state.isOpenModalExcluirPedido,
        })
    }

    statusSPDLOrder(id) {
        switch (id) {
            case 2:
                return "success";
            case 1:
                return "warning";
            default:
                return "warning";
        }
    }

    handleChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    atualizarQtdMelhorEnvio() {
        this.setState({ isLoadingAtualizar: true })
        const _body = {
            qtdMelhorEnvio: this.state.inputQtdMelhorEnvio
        }
        axios.put(this.Configurations.apiBasePath + `/logistica-cile/remessas/atualizar/${this.props.idRemessaDetalhes}`, _body).then(response => {
            this.setState({ flagAtualizar: true })
            // this.props.carregarListaRemessas({});
            this.carregarDetalhesRemessa();
            this.setState({ isLoadingAtualizar: false })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingAtualizar: false }))
    }

    enviarRemessa() {
        this.setState({ isLoadingEnviarRemessa: true })
        axios.post(this.Configurations.apiBasePath + `/logistica-cile/remessas/enviar-arquivo-remessa/${this.state.idRemessa}`).then(response => {
            this.carregarDetalhesRemessa();
        }).catch(this.handleError).finally(() => this.setState({ isLoadingEnviarRemessa: false }))
    }

    toggleEditar() {
        this.setState({
            flagAtualizar: !this.state.flagAtualizar
        })
    }

    editarQtdMelhorEnvio() {
        this.toggleEditar();
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    render() {
        return (
            <React.Fragment>
                <div className="row border-bottom no-gutters"></div>
                {this.state.isLoadingCarregarDetalhesRemessa ? (
                    <div className="row no-gutters">
                        <div className="col-12 text-center py-5">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                    </div>
                ) : (
                    <div className='row py-2'>
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-4'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <p className='m-0'>Id remessa: {this.state.detalhesRemessa.idRemessa} - {moment(this.state.detalhesRemessa.dtColeta).format("DD/MM/YYYY")}</p>
                                        </div>
                                        <div className='col-12'>
                                            <div className='row pt-3 text-center align-items-center'>
                                                <div className='col-4'>
                                                    <span className={`badge badge-spdl badge-${this.statusSPDLOrder(this.state.detalhesRemessa.idStatusRemessa)}`}>{this.state.detalhesRemessa.statusRemessa}</span>
                                                </div>
                                                {(this.state.detalhesRemessa.qtdMelhorEnvio !== 0 || this.state.detalhesRemessa.qtdSPDL !== 0) && (
                                                    <div className='col-6'>
                                                        {this.state.isLoadingEnviarRemessa ? (
                                                            <div className="row">
                                                                <div className="col-12 text-center">
                                                                    <div className="spinner-border text-primary mx-3 text-center" />
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <button onClick={this.enviarRemessa} className="btn btn-outline-info">enviar remessa</button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <p className='m-0'>Quantidade SPDL: <strong>{this.state.detalhesRemessa.qtdSPDL}</strong></p>
                                </div>
                                <div className='col-5'>
                                    <div className="row no-gutters">
                                        {!this.state.flagAtualizar ? (
                                            <div className="col-12">
                                                <div className="row align-items-end">
                                                    <div className="col-12">
                                                        <label>Quantidade Melhor envio: </label>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <input name="inputQtdMelhorEnvio" type="number" className="form-control w-25" autoComplete="off" value={this.state.inputQtdMelhorEnvio} onChange={this.handleChange}></input>
                                                                {this.state.isLoadingAtualizar ? (
                                                                    <div className="spinner-border text-primary mx-3 text-center" />
                                                                ) : (
                                                                    <button className="btn btn-outline-info mx-3" type="button" name="atualizar" onClick={this.atualizarQtdMelhorEnvio}>Atualizar</button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <p>Quantidade Melhor envio: <strong>{this.state.detalhesRemessa.qtdMelhorEnvio}</strong></p>
                                                        {this.state.detalhesRemessa.idStatusRemessa !== 2 && (
                                                            <button className="btn btn-outline-secondary" type="button" name="editar" onClick={this.toggleEditar} >Editar</button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 py-3'>
                            <div className='card cile-lista-pedidos-spdl'>
                                <div className='card-body p-0'>
                                    <ReactTable
                                        data={this.state.detalhesRemessa.listaPedidos}
                                        columns={this.columns}
                                        onFetchData={this.refreshTable}
                                        defaultPageSize={10}
                                        pages={this.state.pages}
                                        manual
                                        loading={this.state.loading}
                                        className="-striped -highlight"
                                        headerClassName="ebs-table-header"
                                        previousText='Anterior'
                                        nextText='Próximo'
                                        loadingText='Carregando...'
                                        noDataText='Nenhum pedido encontrado.'
                                        pageText='Página'
                                        ofText='de'
                                        rowsText='linhas'
                                        pageSizeOptions={[5, 10, 25, 50, 100, 200, 300]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Modal isOpen={this.state.isOpenModalExcluirPedido} toggle={this.toggleModalExcluirPedido}>
                    <ModalHeader toggle={this.toggleModalExcluirPedido}>Excluir remessa</ModalHeader>
                    <ModalBody>
                        Deseja realmente excluir pedido?
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingExcluirPedido ? (
                            <div className="col-6 text-right">
                                <div className="spinner-border text-primary" role="status" />
                            </div>
                        ) : (
                            <Button color="danger" onClick={this.excluirPedido}>Excluir</Button>
                        )}
                        <Button color="secondary" onClick={this.toggleModalExcluirPedido}>Cancelar</Button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}

export default CileSpdlOrders; 